import { motion } from "framer-motion";
import { Rocket, TrendingUp, Target, Zap } from "lucide-react";

export const ForecastCard = ({ forecast, title = "Performance Forecast" }) => {
  const forecastItems = Object.entries(forecast)
    .filter(([key]) => key !== 'note')
    .map(([key, value]) => ({
      label: key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()),
      value: value
    }));

  const icons = [Target, TrendingUp, Zap, Rocket];

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      className="growth-summary"
      data-testid="forecast-card"
    >
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
          <Rocket className="w-5 h-5 text-emerald-600" />
        </div>
        <div>
          <h3 className="font-heading text-xl font-semibold text-slate-800">
            {title}
          </h3>
          <p className="text-sm text-slate-500">
            Expected Next 7 Days
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {forecastItems.map((item, index) => {
          const Icon = icons[index % icons.length];
          return (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: 0.4 + (index * 0.1) }}
              className="bg-white/60 p-4 rounded-lg border border-emerald-200"
            >
              <div className="flex items-center gap-2 mb-2">
                <Icon className="w-4 h-4 text-emerald-600" />
                <span className="text-xs text-slate-500 uppercase tracking-wide">
                  {item.label}
                </span>
              </div>
              <p className="font-heading text-lg font-bold text-slate-800">
                {item.value}
              </p>
            </motion.div>
          );
        })}
      </div>

      {forecast.note && (
        <div className="border-t border-emerald-200 pt-4">
          <p className="text-sm text-slate-600">
            <span className="text-emerald-600 font-semibold">Outlook:</span> {forecast.note}
          </p>
        </div>
      )}
    </motion.div>
  );
};

export default ForecastCard;
